/**
 * Safari often freezes CSS animations (e.g. Bootstrap .spinner-border) when the
 * animated node sat under `display: none` (hidden Bootstrap modal) and is shown
 * again. Replacing the node forces a fresh animation timeline.
 *
 * @param {ParentNode|null|undefined} root
 * @param {string} [selector='.spinner-border']
 */
export function restartCssAnimations(root, selector = ".spinner-border") {
  if (!root?.querySelectorAll) return

  root.querySelectorAll(selector).forEach((el) => {
    el.replaceWith(el.cloneNode(true))
  })
}
